//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export const SHOPPABLE_INSTAGRAM_TYPES = {
  IG_STORY: 'ig_story',
};
